import { NextRequest } from 'next/server'

import { PERSIST_STATE_KEY } from 'Config'

function getAccessToken(): string | undefined {
  if (typeof window === 'undefined') {
    return undefined
  }

  const raw = document.cookie
    .split('; ')
    .find(row => row.startsWith(PERSIST_STATE_KEY))

  if (!raw) return undefined

  try {
    const encoded = raw.split('=')[1]
    const decoded = decodeURIComponent(encoded)
    const parsed = JSON.parse(decoded)

    return parsed.session?.accessToken
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn('[getAccessToken] Failed to parse session cookie', err)
    return undefined
  }
}

function getAccessTokenByRequest(request: NextRequest): string | undefined {
  const rawSession = request.cookies.get(PERSIST_STATE_KEY)?.value

  if (!rawSession) return undefined

  try {
    const decoded = decodeURIComponent(rawSession)
    const parsed = JSON.parse(decoded)
    return parsed.session?.accessToken
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn('[middleware] Failed to parse session cookie', error)
    return undefined
  }
}

export default { getAccessToken, getAccessTokenByRequest }
